import { _ } from "../../core/polyglot/polyglot.js";
import { formatAsDashedYearMonthDay } from "../../core/helpers/date-formatting-util.js";
import { formatForceTwoDecimals } from "../../core/helpers/count-formatting-util.js";
import { getCurrencySymbol } from "../../core/helpers/currency-formatting-util.js";
import GridColumnSpecification from "../../core/widgets/list/GridColumnSpecification.js";

function dateRenderer(aDate, weekNumber) {
	return (html) => {
		if (weekNumber) {
			html.span(
				`${formatAsDashedYearMonthDay(aDate)} (${_(
					"week",
				)} ${weekNumber})`,
			);
		} else if (aDate) {
			html.span(formatAsDashedYearMonthDay(aDate));
		} else {
			html.span("-");
		}
	};
}

function receivableColumnSpec() {
	return columnSpec(_("Customer"));
}

function payableColumnSpec() {
	return columnSpec(_("Supplier"));
}

function columnSpec(partyTitle) {
	return [
		new GridColumnSpecification({
			name: partyTitle,
			sortCriterion: "partyName",
			type: "text",
			renderer: (model) => {
				if (model.getPartyCode()) {
					return `${model.getPartyName()} (${model.getPartyCode()})`;
				}
				return `${model.getPartyName()}`;
			},
		}),
		new GridColumnSpecification({
			name: _("Invoice code"),
			sortCriterion: "invoiceCode",
			type: "text",
			renderer: (model) => model.getInvoiceCodeLabel() || "-",
			dataTestName: "invoice-code",
		}),
		new GridColumnSpecification({
			name: _("Invoice date"),
			sortCriterion: "invoiceDate",
			type: "other",
			renderer: (model, value) => dateRenderer(value),
		}),
		new GridColumnSpecification({
			name: _("Due date"),
			sortCriterion: "dueDate",
			type: "other",
			renderer: (model, value) =>
				dateRenderer(value, model.getDueDateWeekNumber()),
		}),
		new GridColumnSpecification({
			name: _("Currency"),
			sortCriterion: "currencyCode",
			type: "text",
			renderer: (model) => model.getCurrencyCode() || "-",
		}),
		new GridColumnSpecification({
			name: _("Total"),
			sortCriterion: "total",
			type: "number",
			cssClass: "text-right",
			headerCssClass: "text-right",
			renderer: (model, value) => formatForceTwoDecimals(value),
		}),
		new GridColumnSpecification({
			name: _("Balance"),
			sortCriterion: "balance",
			type: "number",
			cssClass: "text-right",
			headerCssClass: "text-right",
			renderer: (model, value) => formatForceTwoDecimals(value),
		}),
		new GridColumnSpecification({
			name: _("Total in {currency}", {
				currency: getCurrencySymbol(),
			}),
			sortCriterion: "convertedTotal",
			type: "number",
			cssClass: "text-right",
			headerCssClass: "text-right",
			renderer: (model, value) => formatForceTwoDecimals(value),
		}),
		new GridColumnSpecification({
			name: _("Balance in {currency}", {
				currency: getCurrencySymbol(),
			}),
			sortCriterion: "convertedBalance",
			type: "number",
			cssClass: "text-right",
			headerCssClass: "text-right",
			renderer: (model, value) => formatForceTwoDecimals(value),
		}),
	];
}

export default {
	receivableColumnSpec,
	payableColumnSpec,
};
